exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Modal-0841c54d{border:0}.Modal-0841c54d a.closeButton-1be88cca{color:#FFF}.header-c70527d0{background-color:#6982FF;border:1px solid #6982FF}.header-c70527d0 h2{color:#f5f5f5}.header-c70527d0 .inner-18bdbe7f{margin-top:20px;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"Modal": "Modal-0841c54d",
	"closeButton": "closeButton-1be88cca",
	"header": "header-c70527d0",
	"inner": "inner-18bdbe7f"
};